// Ring stats fill from 0 and count up when they scroll into view (David 29.9.2026).
const rings = [...document.querySelectorAll('[data-ring]')];
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
if (rings.length && !reduce && 'IntersectionObserver' in window) {
  rings.forEach((r) => {
    r.setAttribute('data-armed', '');
    const v = r.querySelector('[data-ring-value]');
    if (v) { v.dataset.final = v.textContent; v.textContent = '0%'; }
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      const r = en.target;
      const target = Number(r.dataset.ring) || 0;
      const v = r.querySelector('[data-ring-value]');
      requestAnimationFrame(() => r.removeAttribute('data-armed'));
      const t0 = performance.now();
      const dur = 1600;
      const tick = (t) => {
        const k = Math.min(1, (t - t0) / dur);
        const eased = 1 - Math.pow(1 - k, 3);
        if (v) v.textContent = k < 1 ? `${Math.round(target * eased)}%` : v.dataset.final;
        if (k < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.4 });
  rings.forEach((r) => io.observe(r));
}
